module.exports = __webpack_public_path__ + "img/step-5.6d5bdaaf.png";